(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wubs-sti-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const initBundle = (bundle) => {
      if (bundle.dataset.initialized === 'true') return;
      bundle.dataset.initialized = 'true';

      const button = bundle.querySelector('[data-wubs-bundle-add]');
      const status = bundle.querySelector('[data-wubs-bundle-status]');
      const bundleVariantId = Number(bundle.dataset.bundleVariantId);
      const isAvailable = bundle.dataset.available === 'true';
      const errorText = bundle.dataset.error || '';
      const rootUrl = (bundle.dataset.rootUrl || '/').replace(/\/$/, '');

      const buildUrl = (path) => `${rootUrl}${path.startsWith('/') ? path : `/${path}`}`;

      const openCart = () => {
        try {
          if (window.WubsCartDrawer && typeof window.WubsCartDrawer.open === 'function') {
            window.WubsCartDrawer.open();
            if (typeof window.WubsCartDrawer.refresh === 'function') {
              window.WubsCartDrawer.refresh();
            }
          }
        } catch (error) {
          window.location.href = buildUrl('/cart');
          return;
        }

        document.dispatchEvent(new CustomEvent('wubs:cart-open'));
        document.dispatchEvent(new CustomEvent('wubs:cart:add:done'));
      };

      button.addEventListener('click', async () => {
        if (!isAvailable || !bundleVariantId) return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = '';

        try {
          const response = await fetch(buildUrl('/cart/add.js'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: bundleVariantId,
                  quantity: 1
                }
              ]
            })
          });

          if (!response.ok) throw new Error('Cart add failed');
          openCart();
        } catch (error) {
          status.textContent = errorText;
        } finally {
          button.removeAttribute('aria-busy');
          button.disabled = !isAvailable;
        }
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-wubs-sti-bundle]').forEach(initBundle);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
